enum LoadsBulkAction {
    Suspend = 0,
    Reoffer = 1,
    Prioritize = 2,
}

export default LoadsBulkAction;
